import {
	getAspectRatio,
	getAspectRatioType,
	getHeightWidthFromAspectRatio,
} from 'core/utils/utils';
import { RandomPrompt } from '../interface/RandomPrompt.ts';

export class GetRandomPromptResponse {
	randomPrompt: RandomPrompt;

	constructor(data: RandomPrompt) {
		this.randomPrompt = data;
	}

	formatRandomPromptData() {
		const { height, width } = getHeightWidthFromAspectRatio(this.randomPrompt.aspect_ratio);
		return {
			id: this.randomPrompt.prompt_id,

			promptLabel: this.randomPrompt.title,

			modelLabel: this.randomPrompt.model.name,
			model: this.randomPrompt.model.sd_model,
			modelImage: this.randomPrompt.model.image_url,

			sampler: this.randomPrompt.sampler,
			steps: this.randomPrompt.steps,
			guidance: this.randomPrompt.cfg_scale,

			prompt: this.randomPrompt.prompt,
			negativePrompt: this.randomPrompt.negative_prompt,
			seed: this.randomPrompt.seed,
			image: this.randomPrompt.image,

			aspectRatio: getAspectRatio(width / height),
			aspectRatioType: getAspectRatioType(width / height),
			height,
			width,

			creatorHandle: this.randomPrompt.creator.handle,
			creatorImage: this.randomPrompt.creator.image,

			likes: this.randomPrompt.likes,
			liked: this.randomPrompt.liked,
		};
	}
}
